// return true only for x is {}; return false for everthing else
const isDict = (x) => Boolean(x && x.constructor === Object);
const isArray = (x) => Boolean(Array.isArray(x));

export { isDict, isArray };
